module.exports = __webpack_public_path__ + "static/media/fairy-female.79e64dc7.png";